import { RouterModule, Routes } from '@angular/router';
import { AppNotFoundComponent } from './section/not-found';
import { AppLayoutDefaultComponent } from './layout/default';
import {
  apiAuthGuard,
  apiMaintenanceGuard,
  apiNoAuthGuard,
  apiNoMaintenanceGuard,
} from '@app/api';
import { NgModule } from '@angular/core';
import { AppMaintenanceComponent } from './section/maintenance';

export const publicRoutes: Routes = [
  {
    path: '',
    canActivate: [apiNoMaintenanceGuard],
    loadChildren: () => import('./section/auth').then((m) => m.AppAuthModule),
  },
  {
    path: 'auth',
    canActivate: [apiNoMaintenanceGuard],
    loadChildren: () => import('./section/auth').then((m) => m.AppAuthModule),
  },
];

export const secureRoutes: Routes = [
  {
    path: 'travel',
    canActivate: [apiNoMaintenanceGuard],
    loadChildren: () =>
      import('./section/travel').then((m) => m.AppTravelModule),
  },
];

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutDefaultComponent,
    canActivate: [apiNoAuthGuard],
    children: publicRoutes,
  },
  {
    path: '',
    component: AppLayoutDefaultComponent,
    canActivate: [apiAuthGuard],
    children: secureRoutes,
  },
  {
    path: 'maintenance',
    canActivate: [apiMaintenanceGuard],
    component: AppMaintenanceComponent,
  },
  {
    path: '**',
    component: AppNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      enableViewTransitions: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
